import React, { useMemo, useState } from "react";
import MyDropdown from "../../../Common/my-dropdown/my-dropdown-new.component";
import styles from "./plan-select.component.module.scss";
import cn from "../../../../Utils/class-names.utils";
import BaseCheckIcon from "../../../icons/base-ckeck.icon";

interface PlanSelectProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  plans: string[];
  ariaLabel?: string;
}

interface PlanFeature {
  id: string;
  name: string;
  features: string[];
  checked: boolean;
}


const PlanSelect: React.FC<PlanSelectProps> = ({
  id,
  value,
  onChange,
  ariaLabel = "Choose subscription plan",
}) => {
  const [plans, setPlans] = useState<PlanFeature[]>([
    {
      id: "plan-1",
      name: "Paid Plan 1",
      features: [
        "Up to 100 companies",
        "Access to HighGround Academy",
        "Group Onboarding",
      ],
      checked: true,
    },
    {
      id: "plan-2",
      name: "Paid Plan 2",
      features: [
        "100+ companies",
        "Access to HighGround Academy",
        "Group Onboarding",
      ],
      checked: false,
    },
  ]);

  const handleTogglePlan = (planId: string) => {
    setPlans((prevPlans) =>
      prevPlans.map((plan) =>
        plan.id === planId ? { ...plan, checked: !plan.checked } : { ...plan, checked: false },
      ),
    );
  };

  const selectedPlan = useMemo(() => plans.find((plan) => plan.checked)?.name || "", [plans]);

  return (
    <MyDropdown className={cn(styles.dropdown, "w-100")}>
      <MyDropdown.Toggle aria-label={ariaLabel} hideArrow className={cn("w-100")}>
        <div className={cn(styles.selectContainer, "w-100")}>
          <div className={cn(styles.toggle, "w-100")}>
            <span className={styles.toggleText}>{selectedPlan}</span>
          </div>
          <div className="arrow-icon" />
        </div>
      </MyDropdown.Toggle>

      <MyDropdown.Menu className={styles.menu} popperConfig={{ strategy: 'fixed' }} renderOnMount>
        <div
          className={styles.planList}
          role="group"
          aria-label="Plan selection"
        >
          {plans.map((plan, index) => (
            <MyDropdown.Item
              key={plan.id}
              className={styles.planItem}
              onClick={() => handleTogglePlan(plan.id)}
            >
              <div className={styles.checkboxContainer}>
                <button
                  type="button"
                  onClick={() => handleTogglePlan(plan.id)}
                  aria-label={`Toggle ${plan.name}`}
                  aria-checked={plan.checked}
                  role="checkbox"
                  className={cn(styles.checkboxButton, "my-button")}
                  style={{
                    opacity: plan.checked ? 1 : 0,
                  }}
                >
                  <BaseCheckIcon />
                  {/* <BaseCheck className="!relative !w-4 !h-4" /> */}
                </button>
              </div>

              <div className={styles.textContainer}>
                <p className={styles.planText}>
                  <span className={styles.planName}>
                    {plan.name}
                    <br />
                  </span>

                  <span className={styles.planFeatures}>
                    {plan.features.map((feature, featureIndex) => (
                      <React.Fragment key={featureIndex}>
                        &nbsp;&nbsp;&nbsp;&nbsp; {feature}
                        <br />
                      </React.Fragment>
                    ))}
                  </span>
                </p>
              </div>
            </MyDropdown.Item>
          ))}
        </div>
      </MyDropdown.Menu>
    </MyDropdown>
  );
};

export default PlanSelect;

